var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAsana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "177px",
    height: "150px",
    viewBox: "0 0 177 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logos") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.0135415%",
    cy: "54.714503%",
    fx: "50.0135415%",
    fy: "54.714503%",
    r: "71.9292757%",
    gradientTransform: "translate(0.500135,0.547145),scale(0.921739,1.000000),translate(-0.500135,-0.547145)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB900",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F95D8F",
    offset: "60%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F95353",
    offset: "99.9%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "asana-logo",
    transform: "translate(31.000000, 22.000000)",
    fill: "url(#radialGradient-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.9906921,56.1170331 C76.175985,56.1170331 64.97895,67.282887 64.97895,81.056696 C64.97895,94.8318401 76.175985,106 89.9906921,106 C103.803087,106 115,94.8318401 115,81.056696 C115,67.282887 103.803087,56.1170331 89.9906921,56.1170331 Z M25.010525,56.1182468 C11.1981304,56.1194604 0,67.282887 0,81.0579097 C0,94.8318401 11.1981304,105.998786 25.010525,105.998786 C38.824015,105.998786 50.0222671,94.8318401 50.0222671,81.0579097 C50.0222671,67.2827656 38.824015,56.1182468 25.0093079,56.1182468 L25.010525,56.1182468 L25.010525,56.1182468 Z M82.5105859,24.9408766 C82.5105859,38.714807 71.3136726,49.8841806 57.5012779,49.8841806 C43.6865709,49.8841806 32.4895359,38.714807 32.4895359,24.9408766 C32.4895359,11.1669462 43.6865709,0 57.5011562,0 C71.3135508,0 82.5093688,11.1669462 82.5093688,24.9408766 L82.5105859,24.9408766 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAsana);
export default __webpack_public_path__ + "static/media/logo-asana.5c9ced4f9006cfb2d4c10f905cf6d310.svg";
export { ForwardRef as ReactComponent };